
import MButton from "@/components/MButton.vue";
import GoogleLoginButton from "@/components/external_service/GoogleLoginButton.vue";
import MicrosoftLoginButton from "@/components/external_service/MicrosoftLoginButton.vue";
import MTextField from "@/components/form/MTextField.vue";
import store from "@/store";
import { completeSuperAdminEmailLogin } from "@/api/auth";
import { getSuperAdminEmailNotice } from "@/utils/superAdminEmailLogin";
import { Options, Vue } from "vue-class-component";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import {
  GOOGLE_AUTH_CALLBACK_URL,
  MICROSOFT_AUTH_CALLBACK_URL
} from "@/utils/esternal_service";

@Options({
  components: {
    MButton,
    MTextField,
    GoogleLoginButton,
    MicrosoftLoginButton
  },
  watch: {
    "$route.hash": "completeLoginLink"
  }
})
export default class Login extends Vue {
  emailNotice = window.location.hash.startsWith("#adminLogin=")
    ? "認証リンクを確認しています…"
    : "";
  busy = false;

  async mounted() {
    await this.completeLoginLink();
  }

  async completeLoginLink() {
    if (!window.location.hash.startsWith("#adminLogin=")) return;
    this.busy = true;
    this.emailNotice = "認証リンクを確認しています…";
    try {
      if (await completeSuperAdminEmailLogin()) window.location.replace("/");
    } catch (error) {
      this.emailNotice =
        error instanceof Error
          ? error.message
          : "確認リンクが無効です。ログインし直してください。";
    } finally {
      this.busy = false;
    }
  }
  email = "";
  enteredEmail = false;
  password = "";
  enteredPassword = false;

  get validEmail(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
  }

  get validPassword(): boolean {
    return this.password.length >= 8;
  }

  get valid() {
    return this.validEmail && this.validPassword;
  }

  get allEntered(): boolean {
    return this.enteredEmail && this.enteredPassword;
  }

  allEnter() {
    this.enteredEmail = true;
    this.enteredPassword = true;
  }

  returnToLogin() {
    if (this.busy) return;
    this.password = "";
    this.enteredPassword = false;
    this.emailNotice = "";
  }

  async signIn() {
    this.allEnter();

    if (!this.valid || this.busy || this.emailNotice) {
      return;
    }

    this.busy = true;
    try {
      const result = await store.dispatch("signIn", {
        email: this.email,
        password: this.password
      });
      if (result?.emailVerificationRequired) {
        this.password = "";
        this.enteredPassword = false;
        this.emailNotice = getSuperAdminEmailNotice(result.requestLabel);
      }
    } finally {
      this.busy = false;
    }
  }

  async moveToGoogleLinkageUrl() {
    try {
      store.commit("START_LOADING", "リダイレクト中...");
      const call = firebase
        .app()
        .functions("asia-northeast1")
        .httpsCallable("generate_google_linkage_url");
      const res = (await call({
        redirectTo: GOOGLE_AUTH_CALLBACK_URL,
        type: "tutor"
      })) as {
        data: { url: string; status: string };
      };
      const { url, status } = res.data;
      if (status !== "success" || !url) {
        throw new Error("Unexpected error occurred");
      }
      store.commit("END_LOADING");

      window.location.href = url;
    } catch (e) {
      console.error(e);
      alert("リダイレクトに失敗しました。");
      store.commit("END_LOADING");
    }
  }

  async moveToMicrosoftLinkageUrl() {
    try {
      store.commit("START_LOADING", "リダイレクト中...");
      const call = firebase
        .app()
        .functions("asia-northeast1")
        .httpsCallable("generate_microsoft_linkage_url");
      const res = (await call({
        redirectTo: MICROSOFT_AUTH_CALLBACK_URL,
        type: "tutor"
      })) as {
        data: { url: string; status: string };
      };
      const { url, status } = res.data;
      if (status !== "success" || !url) {
        throw new Error("Unexpected error occurred");
      }
      store.commit("END_LOADING");

      window.location.href = url;
    } catch (e) {
      console.error(e);
      alert("リダイレクトに失敗しました。");
      store.commit("END_LOADING");
    }
  }
}
